import React from 'react'
import { Alignment, Button, Colors, Icon, Navbar, Position, Tooltip } from '@blueprintjs/core'
import cx from 'classnames'
import style from '../style.scss'

export const TemplateHeader = ({logo, workspaceId, isLogoAvailable}) => {
    const logoPath = isLogoAvailable ? `/api/v1/bots/___/media/${workspaceId}/${logo}` : logo
    return <>
        <div>
            <header className={cx('bp-header', style.header)}>
                <Navbar>
                    <Navbar.Group>
                        <Navbar.Heading>
                            <div className={cx('bp-sa-title', style.title)}>
                                <a href="javascript:void(0)">
                                    <img width="19" src={logoPath} alt="Your logo" style={{ width: '100%', height: '50px' }} />
                                </a>
                            </div>
                        </Navbar.Heading>
                    </Navbar.Group>
                    {/* <Navbar.Group align={Alignment.RIGHT}>
                    </Navbar.Group> */}
                </Navbar>
            </header>
        </div>
    </>
}
